import { gql } from "@apollo/client";
import { REMITTANCE_ITEM_FRAGMENT } from "./remittanceItemFragment";

const GET_REMITTANCES = gql`
  ${REMITTANCE_ITEM_FRAGMENT}
  query GetRemittances($params: GetRemittanceParams!) {
    remittances(params: $params) {
      total
      page
      limit
      columns {
        key
        title
      }
      items {
        isNew
        checkNo
        purchaser {
          purchaserId
          purchaserName
          purchaserKey
        }
        checkDate
        checkAmount
        remittanceId
        deductedAmount
        remittanceItems {
          ...RemittanceItemFields
        }
      }
    }
  }
`;

export default GET_REMITTANCES;
